import { render, staticRenderFns } from "./approvel-pass-result.vue?vue&type=template&id=e1b361fa&scoped=true"
import script from "./approvel-pass-result.vue?vue&type=script&lang=js"
export * from "./approvel-pass-result.vue?vue&type=script&lang=js"
import style0 from "./approvel-pass-result.vue?vue&type=style&index=0&id=e1b361fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b361fa",
  null
  
)

export default component.exports